export const NAME = "merchant";

export interface Merchant {
  id: number;
  name: string;
  large_image_path: string;
  us_based?: boolean;
}



// WEBPACK FOOTER //
// ./client/modules/Merchant/constants.ts